/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable indent */
/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { DESKTOP, MOBILE, TABLET } from 'helpers/styles/media';

import FormBlock from './FormBlock';
import { FormWrapperStyles } from '../UI/UI';

const FormMain = ({
  formRef,
  isVersion2,
}) => {
  return (
    <FormWrapper
      isVersion2={isVersion2}
      ref={formRef}>
      <FormBlock />
    </FormWrapper>
  );
};

const FormWrapper = styled.div`
  @media ${DESKTOP} {
    display: none;
  }

  @media ${TABLET} {
    position: relative;
    margin: -180px auto 0;

    ${({ isVersion2 }) =>
      isVersion2 &&
      `
        margin: -185px auto 0;
    `}
  }

  @media ${MOBILE} {
    position: relative;
    margin: 40px auto 0;

    ${({ isVersion2 }) =>
      isVersion2 &&
      `
    margin: 37px auto 0;
  `}
  }

  ${FormWrapperStyles}
`;

FormMain.propTypes = {
  formRef: PropTypes.oneOfType([
    PropTypes.shape({
      current: PropTypes.object,
    }),
    PropTypes.func,
  ]).isRequired,
  isVersion2: PropTypes.bool,
};

export default FormMain;
